import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import "./index.css";
import { jsx as e, jsxs as t, Fragment as r } from "react/jsx-runtime";
import { Icon as o } from "@design-system/icon";
import { Tooltip as a } from "@design-system/tooltip";
import { Typography as n } from "@design-system/typography";
import { isBrowser as i } from "@phx-husky/browser-helpers";
import { useScreenRecognition as s } from "@phx-husky/use-screen-recognition";
import l from "classnames";
import { forwardRef as c, useState as h, useEffect as b } from "react";
import { Button as d } from "@design-system/button";
import { Link as p } from "@design-system/link";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function u(e, t, r, o) {
  return new (r || (r = Promise))(function (a, n) {
    function i(e) {
      try {
        l(o.next(e));
      } catch (e) {
        n(e);
      }
    }
    function s(e) {
      try {
        l(o.throw(e));
      } catch (e) {
        n(e);
      }
    }
    function l(e) {
      var t;
      e.done ? a(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(i, s);
    }
    l((o = o.apply(e, t || [])).next());
  });
}
var m = function m(_ref) {
    var t = _ref.label,
      r = _ref.ariaLabel,
      o = _ref.shareContent;
    return e(d, Object.assign({
      className: "cds-share-block__share-button",
      onClick: function onClick() {
        return o();
      },
      variant: "primary",
      "aria-label": r,
      iconPrefix: {
        props: {
          icon: "share"
        }
      }
    }, {
      children: t
    }));
  },
  v = function v(_ref2) {
    var t = _ref2.shareLinks,
      r = _ref2.label,
      o = _ref2.ariaLabel,
      a = _ref2.shareContent,
      n = _ref2.location;
    return (null == t ? void 0 : t.length) ? e("ul", Object.assign({
      "aria-labelledby": "share-block",
      className: "cds-share-block__items"
    }, {
      children: t.map(function (t) {
        var r = t.href,
          _t$size = t.size,
          o = _t$size === void 0 ? "large" : _t$size,
          _t$variant = t.variant,
          a = _t$variant === void 0 ? "subtle-icon" : _t$variant,
          i = function (e, t) {
            var r = {};
            for (var o in e) {
              Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
            }
            if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
              var a = 0;
              for (o = Object.getOwnPropertySymbols(e); a < o.length; a++) {
                t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (r[o[a]] = e[o[a]]);
              }
            }
            return r;
          }(t, ["href", "size", "variant"]);
        return e("li", Object.assign({
          className: "cds-share-block__item"
        }, {
          children: e(p, Object.assign({
            className: "cds-share-block__share-link",
            size: o,
            variant: a,
            href: "".concat(r).concat(n)
          }, i))
        }), r);
      })
    })) : e(m, {
      ariaLabel: o,
      shareContent: a,
      label: r
    });
  },
  y = c(function (_ref3, w) {
    var c = _ref3.className,
      d = _ref3.shareLinks,
      p = _ref3.label,
      _ref3$titleOptions = _ref3.titleOptions,
      y = _ref3$titleOptions === void 0 ? {
        variant: "body",
        tag: "p",
        size: "s"
      } : _ref3$titleOptions,
      f = _ref3.showCopyButton,
      g = _ref3.copyButtonAriaLabel,
      k = _ref3.shareButtonAriaLabel,
      O = _ref3.copyButtonDefaultLabel,
      j = _ref3.copyButtonActiveLabel,
      _ref3$align = _ref3.align,
      _ = _ref3$align === void 0 ? "start" : _ref3$align;
    var _h = h(""),
      _h2 = _slicedToArray(_h, 2),
      L = _h2[0],
      x = _h2[1],
      _h3 = h(O),
      _h4 = _slicedToArray(_h3, 2),
      C = _h4[0],
      N = _h4[1],
      _s = s(),
      B = _s.isMobile;
    b(function () {
      return x(i() ? window.location.href : "");
    }, []);
    var P = function P() {
      return u(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return null === navigator || void 0 === navigator ? void 0 : navigator.share({
                  url: L
                });
              case 3:
                return _context.abrupt("return", _context.sent);
              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", (console.error("Error while sharing content", _context.t0), null));
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));
    };
    return e("div", Object.assign({
      ref: w,
      className: l("cds-share-block", c, "cds-share-block--align-".concat(_)),
      "data-testid": "cds-share-block"
    }, {
      children: B ? e(m, {
        ariaLabel: k,
        shareContent: P,
        label: p
      }) : t(r, {
        children: [(null == d ? void 0 : d.length) ? t("div", Object.assign({
          className: "cds-share-block__header"
        }, {
          children: [e(o, {
            icon: "share"
          }), p && e(n, Object.assign({
            className: "cds-share-block__title"
          }, Object.assign(Object.assign({}, y), {
            content: "".concat(p, ":")
          })))]
        })) : null, e(v, {
          shareLinks: d,
          label: p,
          ariaLabel: k,
          location: L,
          shareContent: P
        }), f ? e(a, {
          className: "cds-share-block__tooltip",
          label: g,
          portalQuerySelector: ".cds-tooltip",
          isTooltipContentInteractive: !0,
          icon: "copy",
          onClickTooltip: function onClickTooltip() {
            return e = L, u(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var t;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      N(j);
                      _context2.next = 4;
                      return null === (t = null === navigator || void 0 === navigator ? void 0 : navigator.clipboard) || void 0 === t ? void 0 : t.writeText(e);
                    case 4:
                      return _context2.abrupt("return", _context2.sent);
                    case 7:
                      _context2.prev = 7;
                      _context2.t0 = _context2["catch"](0);
                      return _context2.abrupt("return", (console.error("Error while copy to clipboard", _context2.t0), null));
                    case 10:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[0, 7]]);
            }));
            var e;
          },
          onBlurTooltip: function onBlurTooltip() {
            return N(O);
          },
          content: e("span", {
            children: C
          })
        }) : null]
      })
    }));
  });
export { y as ShareBlock };